import React, { useState } from "react";
import styles from "../HealthChat.module.css";

/* ─── Data Lookup (Same as Detail Screen) ─── */
const PROGRAM_CONTENT = {
  pcos: {
    title: "PCOS Care Program",
    price: "₹1,999",
    rawPrice: 1999,
    subtotal: "₹2,499",
    discount: "₹500",
  },
  fertility: {
    title: "Fertility Boost Program",
    price: "₹2,999",
    rawPrice: 2999,
    subtotal: "₹3,499",
    discount: "₹500",
  },
  pregnancy: {
    title: "Healthy Pregnancy Program",
    price: "₹4,999",
    rawPrice: 4999,
    subtotal: "₹5,499",
    discount: "₹500",
  },
};

/* ─── Payment Logos (Simplified for implementation) ─── */
const RazorpayLogo = () => (
  <span style={{ fontSize: "12px", fontWeight: "bold", color: "#2b3481" }}>
    <span style={{ color: "#3399cc" }}>▲</span> Razorpay
  </span>
);

export default function CheckoutScreen({ programId, onBack, onSelect }) {
  const [paymentMethod, setPaymentMethod] = useState("upi");

  // Look up the selected program data
  const data = PROGRAM_CONTENT[programId] || PROGRAM_CONTENT.pcos;

  const paymentOptions = [
    {
      id: "upi",
      label: "UPI",
      icons: [
        "https://i.pinimg.com/originals/ae/5f/e3/ae5fe3dc423e44c0ddbef5dc64fa356b.png",
        "https://static.vecteezy.com/system/resources/previews/020/190/501/non_2x/paytm-logo-paytm-icon-free-free-vector.jpg",
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyVO9LUWF81Ov6LZR50eDNu5rNFCpkn0LwYQ&s",
      ],
    },
    {
      id: "card",
      label: "Credit / Debit Card",
      icons: [
        "https://d28wu8o6itv89t.cloudfront.net/images/visalogopngtransparentpng-1579588235384.png",
        "https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg",
        "https://upload.wikimedia.org/wikipedia/commons/c/cb/Rupay-Logo.png?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=originalhttps://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxHMc4G10g50AR1rpWnA7tfomg96N1LvrG2g&s",
      ],
    },
    { id: "netbanking", label: "Net Banking", icons: [] },
    { id: "wallets", label: "Wallets", icons: [] },
  ];

  return (
    <div className={styles.programsScreen}>
      <button className={styles.selectDoctorBack} onClick={onBack}>
        ← Back
      </button>

      {/* Program Card - NOW DYNAMIC */}
      <div className={styles.programBriefCard}>
        <div className={styles.lotusIcon}>🪷</div>
        <div className={styles.programBriefInfo}>
          <h3 className={styles.briefTitle}>{data.title}</h3>
          <p className={styles.briefDuration}>3 months access</p>
        </div>
        <div className={styles.briefPrice}>{data.price}</div>
      </div>

      {/* Order Summary - NOW DYNAMIC */}
      <div className={styles.orderSummarySection}>
        <h2 className={styles.summaryHeading}>Order summary</h2>
        <div className={styles.summaryRow}>
          <span>Subtotal</span>
          <span>{data.subtotal}</span>
        </div>
        <div className={`${styles.summaryRow} ${styles.discountText}`}>
          <span>Discount</span>
          <span>- {data.discount}</span>
        </div>
        <div className={styles.summaryDivider} />
        <div className={`${styles.summaryRow} ${styles.totalRow}`}>
          <span>Total</span>
          <span>{data.price}</span>
        </div>
        <p className={styles.taxNote}>Inclusive of all taxes</p>
      </div>

      {/* Payment Methods */}
      <div className={styles.paymentSection}>
        <h2 className={styles.summaryHeading}>Payment methods</h2>
        <div className={styles.methodsList}>
          {paymentOptions.map((option) => (
            <label
              key={option.id}
              className={`${styles.paymentOption} ${paymentMethod === option.id ? styles.selectedOption : ""}`}
            >
              <input
                type="radio"
                name="payment"
                checked={paymentMethod === option.id}
                onChange={() => setPaymentMethod(option.id)}
                className={styles.radioInput}
              />
              <div className={styles.radioCircle}>
                {paymentMethod === option.id && (
                  <div className={styles.radioInner} />
                )}
              </div>
              <span className={styles.methodLabel}>{option.label}</span>
              <div className={styles.methodIcons}>
                {option.icons.map((icon, idx) => (
                  <img
                    key={idx}
                    src={icon}
                    alt="provider"
                    className={styles.providerIcon}
                  />
                ))}
              </div>
            </label>
          ))}
        </div>
      </div>

      <button className={styles.visitModelContinueBtn} onClick={onSelect}>
        Pay {data.price}
      </button>

      <div className={styles.secureFooter}>
        <p>
          100% secure payments powered by <RazorpayLogo />
        </p>
      </div>
    </div>
  );
}
